import { ChangeDetectorRef, Component } from '@angular/core';
import { ApiService } from '@/apiConnection/ApiService';
import { Urls } from '@/apiConnection/urls';
import { Utils } from '@/utils/utils';

@Component({
  templateUrl: './backup.page.html',
})
export class BackupPage {

  running = false;
  lastMessage: string | null = null;
  // URL de consentimiento de Google cuando el backend no puede usar el token de
  // Google Drive (caducado/revocado/ausente). Abrirla y aceptar hace que el
  // backend (GET /api/google-drive/callback) guarde un token nuevo.
  authorizationUrl: string | null = null;
  copied = false;

  constructor(
    private apiService: ApiService,
    private cdr: ChangeDetectorRef,
  ) { }

  runBackup(): void {
    if (this.running) return;

    this.running = true;
    this.lastMessage = null;
    this.authorizationUrl = null;
    this.copied = false;

    this.apiService.post(Urls.urls.backupsRun, {}).subscribe({
      next: (response: any) => {
        this.running = false;
        this.lastMessage = response?.message ?? 'Copia de seguridad generada correctamente.';
        Utils.notification.success(this.lastMessage!);
        this.cdr.detectChanges();
      },
      error: (error: any) => {
        this.running = false;
        const message = Utils.extractErrorMessage(error) || 'Error al generar la copia de seguridad';

        // ErrorInterceptor reduce el error a su `message`, así que el campo
        // `authorization_url` de la respuesta no llega aquí - pero el backend
        // también incluye la URL al final del mensaje.
        const match = message.match(/https:\/\/accounts\.google\.com\/\S+/);
        this.authorizationUrl = match ? match[0] : null;

        if (this.authorizationUrl) {
          this.lastMessage = 'La autorización de Google Drive ha caducado o no existe. Abre el enlace de abajo, inicia sesión con la cuenta de Google de las copias y acepta el permiso. Después vuelve a lanzar la copia.';
          Utils.notification.alert('Hay que volver a autorizar Google Drive');
        } else {
          Utils.notification.alert(message);
        }
        this.cdr.detectChanges();
      },
    });
  }

  copyAuthorizationUrl(): void {
    if (!this.authorizationUrl) return;

    navigator.clipboard.writeText(this.authorizationUrl).then(() => {
      this.copied = true;
      this.cdr.detectChanges();
    });
  }
}
